// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import http from "./utils/api";
import {
  httpGet,
  httpPost,
  httpPostIsAnonymous,
  httpPostToken,
  baseUrl,
  baseAuthUrl
} from "./utils/httpService";
import {
  checkPhoneNum,
  checkEmail,
  getRandomVerify,
  convertDate,
  forTime,
  formatTime,
  formateDate,
  formatDateTime,
  repairZero,
  formatSeconds
} from "./utils/util";
import { Debounce, Throttle } from "./utils/public";
import "./assets/style/reset.scss";
import "element-ui/lib/theme-chalk/display.css";
import "../theme/index.css";
import "./assets/style/media.scss";
import "./assets/style/iconfont.css";
import { Message } from "element-ui";
import "babel-polyfill";

// cookie
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

Vue.prototype.$http = http;

Vue.config.productionTip = false;

Vue.prototype.httpGet = httpGet;
Vue.prototype.httpPost = httpPost;
Vue.prototype.httpPostIsAnonymous = httpPostIsAnonymous;
Vue.prototype.httpPostToken = httpPostToken;
Vue.prototype.baseUrl = baseUrl;
Vue.prototype.baseAuthUrl = baseAuthUrl;
Vue.prototype.checkPhoneNum = checkPhoneNum;
Vue.prototype.checkEmail = checkEmail;
Vue.prototype.getRandomVerify = getRandomVerify;
Vue.prototype.convertDate = convertDate;
Vue.prototype.forTime = forTime;
Vue.prototype.formatTime = formatTime;
Vue.prototype.formateDate = formateDate;
Vue.prototype.formatDateTime = formatDateTime;
Vue.prototype.repairZero = repairZero;
Vue.prototype.formatSeconds = formatSeconds;
Vue.prototype.Throttle = Throttle;
Vue.prototype.Debounce = Debounce;

// // 路由拦截
router.beforeEach((to, from, next) => {
  console.log(to.path);
  let whiteList = [
    "Home",
    "Link",
    "User",
    "Pricing",
    "App",
    "Apply",
    "Register"
  ];
  if (whiteList.includes(to.name)) {
    next();
  } else if (to.name == "Login") {
    if (VueCookies.get("tokenWeb")) {
      next("/apply");
    } else {
      next();
    }
  } else if (to.name == "Pay") {
    if (VueCookies.get("tokenWeb")) {
      next();
    } else {
      next("/login");
    }
  } else {
    if (VueCookies.get("tokenWeb")) {
      //vuex获取当前token是否存在
      let userInfo = VueCookies.get("userInfo");
      let isRequestor = VueCookies.get("isRequestor");
      if (userInfo.workerId && isRequestor) {
        next();
      } else if (userInfo.workerId && !isRequestor) {
        Vue.prototype.httpPost("/web/manage/v1/checkIsRequestor").then(res => {
          if (res.code == 0) {
            if (res.data.isRequestor) {
              VueCookies.set("isRequestor", res.data.isRequestor);
              next();
            } else {
              next("/apply");
            }
          }
        });
      } else {
        let params = {
          uumsId: userInfo.userId,
          tokenContext: userInfo
        };
        Vue.prototype
          .httpPost("web/manage/v1/getManageId", params)
          .then(res => {
            if (res.code == 0) {
              userInfo.workerId = res.data;
              VueCookies.set("userInfo", userInfo);
              Vue.prototype
                .httpPost("/web/manage/v1/checkIsRequestor")
                .then(res => {
                  if (res.code == 0) {
                    if (res.data.isRequestor) {
                      VueCookies.set("isRequestor", res.data.isRequestor);
                      next();
                    } else {
                      next("/apply");
                    }
                  }
                });
            } else {
              next("/login");
            }
          });
      }
    } else {
      next({
        path: "/login"
      });
    }
  }
});

//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js